import { render, staticRenderFns } from "./AboutDialog.vue?vue&type=template&id=9d6a7a1e&scoped=true&"
import script from "./AboutDialog.vue?vue&type=script&lang=ts&"
export * from "./AboutDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AboutDialog.vue?vue&type=style&index=0&id=9d6a7a1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6a7a1e",
  null
  
)

export default component.exports